import React, { useState } from "react";
import { Form, Modal, ModalBody, ModalHeader } from "reactstrap";
import { toaster } from "../../services/helper";
import Textinput from "../../Components/Common/Textinput";
import ReactButton from "../../Components/Common/ReactButton";
import Validators from "../../Components/validations/Validator";
import { API, HELPER } from "../../services";
import { apiConfig } from "../../configs";

const ChangePassword = ({ modal, toggle, setModal }) => {
  const [isLoader, setIsLoader] = useState(false);
  //  -------------formState --------------
  const [formState, setFormState] = useState({
    oldPassword: "",
    newPassword: "",
  });
  //  -------------Validation --------------
  const rules = {
    oldPassword: "required",
    newPassword: "required",
  };
  //  -------------handle Change Password --------------
  const handleSubmit = (data) => {
    setIsLoader(true);
    API.put(apiConfig.changePassword, data)
      .then((res) => {
        toaster.success("Change Password successfully");
        setModal(false);
      })
      .catch(HELPER.showErrorToaster)
      .finally(() => {
        setIsLoader(false);
      });
  };
  // -----------------onChange--------------------
  const onChange = ({ target: { value, name } }) => {
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    // -------------------Change Password Modal---------------------
    <div>
      <Modal id="showModal" isOpen={modal} toggle={toggle} centered>
        <ModalHeader className="bg-light p-3" toggle={toggle}>
          Change Password
        </ModalHeader>
        <ModalBody>
          <Validators formData={formState} rules={rules}>
            {({ onSubmit, errors }) => {
              return (
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit(handleSubmit);
                  }}
                  action="#"
                >
                  <Textinput
                    label={"Old Password"}
                    value={formState.oldPassword}
                    name="oldPassword"
                    placeholder="Enter Old Password"
                    error={errors?.oldPassword}
                    type="password"
                    onChange={onChange}
                  // className="py-[10px] pl-[20px] pr-[20px] text-sm h-[37px] border w-[220px] rounded-[10px] text-[#552F62] outline-none placeholder-[#552F62] font-medium"
                  />
                  <Textinput
                    label={"New Password"}
                    value={formState.newPassword}
                    name="newPassword"
                    placeholder="Enter New Password"
                    error={errors?.newPassword}
                    type="password"
                    onChange={onChange}
                  // className="py-[10px] pl-[20px] pr-[20px] text-sm h-[37px] border w-[220px] rounded-[10px] text-[#552F62] outline-none placeholder-[#552F62] font-medium"
                  />
                  <div className="mt-4">
                    <ReactButton
                      loader={isLoader}
                      color="success"
                      className="btn btn-success w-100"
                      type="submit"
                    >
                      Submit
                    </ReactButton>
                  </div>
                </Form>
              );
            }}
          </Validators>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ChangePassword;
